import * as _uniq from 'lodash/uniq';

export function uniq<T>(values: T[]): T[] {
  return _uniq(values);
}

